module.exports = __webpack_public_path__ + "static/Ranger_Drizzt_and_guenhwyvar-b77c2b69232ffeab5b9f4353a5fea4c0.webp";